import { getAuthAxiosBackend } from "../../helpers/axios"

class InjuryServices{

    get(id){
        return getAuthAxiosBackend().get('tasdeed/woundeds/'+id.toString())
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('tasdeed/woundeds', {params: data})
    }

    delete(id){
        return getAuthAxiosBackend().delete('tasdeed/woundeds/' + id)
    }
}

export default new InjuryServices()